// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"QuickActions_ProseMirror__26pDX","quickActions":"QuickActions_quickActions__1uQ4P","rotate-shadow":"QuickActions_rotate-shadow__2rFNT"};